import type { InvoiceLinePayload } from '../types/agreements.types';

export const APPROVAL_CODE_LENGTH = 6;

const lineIdentity = (line: InvoiceLinePayload): string =>
    line.kind === 'service' ? `service:${line.agreement_service_id}` : `item:${line.agreement_item_id}`;

export const fundingSelectionKey = (lines: InvoiceLinePayload[]): string =>
    lines.map(lineIdentity).sort().join('|');

export const normaliseCode = (raw: string): string => raw.replace(/\D/g, '').slice(0, APPROVAL_CODE_LENGTH);

export const isCompleteCode = (code: string): boolean => new RegExp(`^\\d{${APPROVAL_CODE_LENGTH}}$`).test(code);
